import { c as __assign } from '../../../tslib.es6-80f01feb.js';
import { makeObservable, observable, action } from 'mobx';
import '../enums/GameSpecificTypes.js';
import '../enums/Chat.js';
import '../enums/GameModes.js';
import '../enums/IconTypes.js';
import '../enums/BetStatus.js';
import '../enums/PopupTypes.js';
import '../enums/ApiVersion.js';
import '../enums/RoundStatus.js';
import '../enums/RequestStatus.js';
import '../enums/FreeBetsStatus.js';
import '../enums/SocketEvents.js';
import '../enums/TranslationKeys.js';
import '../enums/ApiServiceTypes.js';
import '../enums/EnvironmentTypes.js';
import { DefaultQueryParams } from '../enums/DefaultQueryParams.js';
import '../enums/BetHistoryFilterTypes.js';
import { GameTheme, GameThemeNames } from '../enums/GameThemeTypes.js';
import '../enums/FetchDefaultPaths.js';
import '../enums/ResponseCodes.js';
import { parseQuery } from '../helpers/parseQuery.js';
import '../../../moment-27179cac.js';
import '../../../_commonjsHelpers-4c2b67c2.js';

var UserSettingsStore = /** @class */ (function () {
    function UserSettingsStore() {
        var _a, _b;
        this.localStorageSuffix = '_userSettings';
        this.soundService = null;
        this.localStorageKey = '';
        this.isAnimationOn = true;
        this.isMusicOn = true;
        this.musicVolume = 0.5;
        this.isSoundOn = true;
        this.soundVolume = 0.5;
        this.gameThemeType = ((_a = parseQuery(window.location.search)) === null || _a === void 0 ? void 0 : _a[DefaultQueryParams.Theme])
            ? +GameTheme[(_b = parseQuery(window.location.search)) === null || _b === void 0 ? void 0 : _b[DefaultQueryParams.Theme]]
            : GameTheme.Standart;
        this.isDarkModeOn = false;
        this.isWinterModeOn = false;
        this.isFullScreen = false;
        this.allowFullScreen = false;
        makeObservable(this, {
            isMusicOn: observable,
            isFullScreen: observable,
            musicVolume: observable,
            isSoundOn: observable,
            soundVolume: observable,
            isAnimationOn: observable,
            gameThemeType: observable,
            isDarkModeOn: observable,
            isWinterModeOn: observable,
            allowFullScreen: observable,
            setIsMusicOn: action.bound,
            setIsMusicOnValue: action.bound,
            setMusicVolume: action.bound,
            setIsSoundOn: action.bound,
            setSoundVolume: action.bound,
            setIsDarkModeOn: action.bound,
            setGameThemeType: action.bound,
            setIsWinterModeOn: action.bound,
            setIsMusicOnAndIsSoundOn: action.bound,
            setIsAnimationOn: action.bound,
            localStorageAndUserSettingsInit: action.bound,
            setIsFullScreen: action.bound,
            toggleFullscreen: action.bound,
            openFullScreen: action.bound,
            closeFullScreen: action.bound,
            setAllowFullScreen: action.bound,
        });
    }
    UserSettingsStore.prototype.localStorageAndUserSettingsInit = function (_a) {
        var gamePrefix = _a.gameName, soundService = _a.soundService;
        this.localStorageKey = gamePrefix + this.localStorageSuffix;
        this.soundService = soundService;
        var _b = parseQuery(window.location.search), _c = DefaultQueryParams.Theme, themeName = _b[_c];
        var userSettings = JSON.parse(localStorage.getItem(this.localStorageKey));
        var defSettings = {
            isMusicOn: this.isMusicOn,
            musicVolume: this.musicVolume,
            isSoundOn: this.isSoundOn,
            soundVolume: this.soundVolume,
            isDarkModeOn: this.isDarkModeOn,
            isWinterModeOn: this.isWinterModeOn,
            isAnimationOn: this.isAnimationOn,
            gameThemeType: this.gameThemeType,
        };
        if (userSettings === null || Object.keys(defSettings).length !== Object.keys(userSettings).length) {
            localStorage.setItem(this.localStorageKey, JSON.stringify(defSettings));
        }
        else {
            var isMusicOn = userSettings.isMusicOn, musicVolume = userSettings.musicVolume, isSoundOn = userSettings.isSoundOn, soundVolume = userSettings.soundVolume, isDarkModeOn = userSettings.isDarkModeOn, isWinterModeOn = userSettings.isWinterModeOn, isAnimationOn = userSettings.isAnimationOn, gameThemeType = userSettings.gameThemeType;
            this.isMusicOn = isMusicOn;
            this.musicVolume = musicVolume;
            this.isSoundOn = isSoundOn;
            this.soundVolume = soundVolume;
            this.isDarkModeOn = isDarkModeOn;
            this.isWinterModeOn = isWinterModeOn;
            this.isAnimationOn = isAnimationOn;
            this.gameThemeType = gameThemeType;
        }
        if (this.gameThemeType && this.gameThemeType !== +GameTheme[themeName]) {
            this.gameThemeType = GameTheme[GameThemeNames.Standart];
        }
    };
    UserSettingsStore.prototype.updateLocalStorage = function (updatedSettings) {
        if (localStorage.getItem(this.localStorageKey)) {
            var updatedUserSettings = __assign(__assign({}, JSON.parse(localStorage.getItem(this.localStorageKey))), updatedSettings);
            localStorage.setItem(this.localStorageKey, JSON.stringify(updatedUserSettings));
        }
        else {
            console.error('PLEASE INIT YOUR LOCAL STORAGE');
        }
    };
    UserSettingsStore.prototype.setIsMusicOn = function () {
        this.soundService.muteMusic(this.isMusicOn);
        this.updateLocalStorage({
            isMusicOn: !this.isMusicOn,
        });
        this.isMusicOn = !this.isMusicOn;
    };
    UserSettingsStore.prototype.setIsAnimationOn = function () {
        this.updateLocalStorage({
            isAnimationOn: !this.isAnimationOn,
        });
        this.isAnimationOn = !this.isAnimationOn;
    };
    UserSettingsStore.prototype.setIsMusicOnAndIsSoundOn = function (isMuteAll) {
        if (isMuteAll === void 0) { isMuteAll = false; }
        if (this.isMusicOn || this.isSoundOn || isMuteAll) {
            this.isMusicOn = false;
            this.isSoundOn = false;
            this.soundService.muteMusic(true);
            this.soundService.muteSounds(true);
        }
        else {
            this.isMusicOn = true;
            this.isSoundOn = true;
            this.soundService.muteMusic(false);
            this.soundService.muteSounds(false);
        }
        this.updateLocalStorage({
            isMusicOn: this.isMusicOn,
            isSoundOn: this.isSoundOn,
        });
    };
    UserSettingsStore.prototype.setMusicVolume = function (musicVolume) {
        this.soundService.changeMusicVolume(musicVolume);
        var isMusicOn = +musicVolume === 0 || !this.isMusicOn ? !this.isMusicOn : this.isMusicOn;
        this.updateLocalStorage({
            musicVolume: musicVolume,
            isMusicOn: isMusicOn,
        });
        this.musicVolume = musicVolume;
        this.isMusicOn = isMusicOn;
        this.soundService.muteMusic(!isMusicOn);
    };
    UserSettingsStore.prototype.setIsSoundOn = function () {
        this.soundService.muteSounds(this.isSoundOn);
        this.updateLocalStorage({
            isSoundOn: !this.isSoundOn,
        });
        this.isSoundOn = !this.isSoundOn;
    };
    UserSettingsStore.prototype.setSoundVolume = function (soundVolume) {
        this.soundService.changeSoundsVolume(soundVolume);
        var isSoundOn = +soundVolume === 0 || !this.isSoundOn ? !this.isSoundOn : this.isSoundOn;
        this.updateLocalStorage({
            soundVolume: soundVolume,
            isSoundOn: isSoundOn,
        });
        this.soundVolume = soundVolume;
        this.isSoundOn = isSoundOn;
        this.soundService.muteSounds(!isSoundOn);
    };
    UserSettingsStore.prototype.setIsDarkModeOn = function () {
        this.updateLocalStorage({
            isDarkModeOn: !this.isDarkModeOn,
        });
        this.isDarkModeOn = !this.isDarkModeOn;
    };
    UserSettingsStore.prototype.setIsWinterModeOn = function () {
        this.updateLocalStorage({
            isWinterModeOn: !this.isWinterModeOn,
        });
        this.isWinterModeOn = !this.isWinterModeOn;
    };
    UserSettingsStore.prototype.setGameThemeType = function () {
        var _a = parseQuery(window.location.search), _b = DefaultQueryParams.Theme, themeName = _a[_b];
        if (!!this.gameThemeType || !GameTheme[themeName]) {
            this.gameThemeType = GameTheme[GameThemeNames.Standart];
        }
        else {
            this.gameThemeType = +GameTheme[themeName];
        }
        this.updateLocalStorage({
            gameThemeType: this.gameThemeType,
        });
    };
    UserSettingsStore.prototype.setIsMusicOnValue = function (state) {
        this.isMusicOn = state;
    };
    Object.defineProperty(UserSettingsStore.prototype, "document", {
        get: function () {
            return window.document;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserSettingsStore.prototype, "htmlElement", {
        get: function () {
            return document.documentElement;
        },
        enumerable: false,
        configurable: true
    });
    UserSettingsStore.prototype.setIsFullScreen = function (bool) {
        this.isFullScreen = bool;
    };
    UserSettingsStore.prototype.setAllowFullScreen = function (bool) {
        this.allowFullScreen = bool;
    };
    UserSettingsStore.prototype.toggleFullscreen = function () {
        !this.isFullScreen ? this.openFullScreen() : this.closeFullScreen();
    };
    UserSettingsStore.prototype.openFullScreen = function () {
        switch (true) {
            case !!this.htmlElement.requestFullscreen:
                this.htmlElement.requestFullscreen().catch(function (err) { return console.log(err); });
                break;
            case !!this.htmlElement.mozRequestFullScreen /* Firefox */:
                this.htmlElement.mozRequestFullScreen();
                break;
            case !!this.htmlElement.webkitRequestFullscreen /* Chrome, Safari and Opera */:
                this.htmlElement.webkitRequestFullscreen();
                break;
            case !!this.htmlElement.msRequestFullscreen /* IE/Edge */:
                this.htmlElement.msRequestFullscreen();
                break;
        }
    };
    UserSettingsStore.prototype.closeFullScreen = function () {
        switch (true) {
            case !!this.document.exitFullscreen:
                this.document.exitFullscreen().catch(function (err) { return console.log(err); });
                break;
            case !!this.document.mozCancelFullScreen /* Firefox */:
                this.document.mozCancelFullScreen();
                break;
            case !!this.document.webkitExitFullscreen /* Chrome, Safari and Opera */:
                this.document.webkitExitFullscreen();
                break;
            case !!this.document.msExitFullscreen /* IE/Edge */:
                this.document.msExitFullscreen();
                break;
        }
    };
    return UserSettingsStore;
}());
var userSettingsStore = new UserSettingsStore();

export { UserSettingsStore, userSettingsStore };
